import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingSmall } from "./LoadingSmall";

interface Props {
  title?: string;
  description?: string;
  confirmButtonText?: string;
  trigger?: React.ReactNode;
  onConfirm: () => void;
  isLoading?: boolean;
}

export interface ConfirmActionDialogRef {
  close: () => void;
}

export const ConfirmActionDialog = forwardRef<ConfirmActionDialogRef, Props>(
  ({ title, description, confirmButtonText, trigger, onConfirm, isLoading }, ref) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(
      ref,
      () => ({
        close: () => setIsOpen(false),
      }),
      []
    );

    return (
      <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
        <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{title || t("Are you sure?")}</AlertDialogTitle>
            <AlertDialogDescription>{description || t("This action cannot be undone.")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("common.dismiss")}</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => {
                e.preventDefault();
                onConfirm();
              }}
              disabled={isLoading}
            >
              {confirmButtonText || t("common.confirm")} {isLoading && <LoadingSmall />}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
  }
);
